/**
 * LoyaltyLion "Points for product" – keeps the points line under the Add to cart
 * button in sync with the selected variant on the PDP.
 *
 * Markup: snippets/loyaltylion-product-points.liquid
 * Docs:   https://developers.loyaltylion.com/sdk/simple-components/points-for-product
 *
 * Listens to the theme's `variantChange` event on .product-main-element (dispatched by
 * <product-variants> in assets/product_main.js), then:
 *  1. updates the hidden price element with the new variant price
 *  2. swaps the product id for linked/grouped products (variants can belong to another product)
 *  3. asks the LoyaltyLion SDK to re-render its components
 */
if (!customElements.get('loyaltylion-product-points')) {
  class LoyaltyLionProductPoints extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this.mainElement = this.closest('.product-main-element');
      this.priceElement = this.querySelector('[data-lion-price-for-product-id]');
      this.pointsElement = this.querySelector('[data-lion-points-for-product-id]');
      if (!this.mainElement || !this.priceElement || !this.pointsElement) return;

      this._bound = true;
      this.mainElement.addEventListener('variantChange', (event) => {
        this.update(event.detail && event.detail.variant);
      });
    }

    getProductId(variant) {
      var data = this.mainElement.productData || {};
      var groups = data.groupDetails && data.groupDetails.groups;
      if (groups && groups[variant.id] && groups[variant.id].prod_id) {
        return String(groups[variant.id].prod_id);
      }
      return this.dataset.productId;
    }

    formatPrice(cents) {
      if (window.$s && typeof window.$s.formatMoney === 'function') {
        return window.$s.formatMoney(cents);
      }
      return (cents / 100).toFixed(2);
    }

    update(variant) {
      if (!variant) return;
      var productId = this.getProductId(variant);
      var price = this.formatPrice(variant.price);

      var changed =
        this.priceElement.textContent.trim() !== price ||
        this.priceElement.getAttribute('data-lion-price-for-product-id') !== productId;
      if (!changed) return;

      this.priceElement.setAttribute('data-lion-price-for-product-id', productId);
      this.pointsElement.setAttribute('data-lion-points-for-product-id', productId);
      this.priceElement.textContent = price;
      this.refresh();
    }

    refresh() {
      var ll = window.loyaltylion;
      if (ll && ll.ui && typeof ll.ui.refresh === 'function') {
        ll.ui.refresh();
      }
    }
  }

  customElements.define('loyaltylion-product-points', LoyaltyLionProductPoints);
}
